import React from 'react';
import SubjectItem from './SubjectItem.jsx';

// grouping of subjects / qualifications by qualification type
// props : qualification (HN, etc that gets mapped to full name), items (individual subjects / qualifications)
// no interactivity

var QualificationDetails = React.createClass({

    render: function(){

        console.log(this.props);

        const items = this.props.items.map( ( item ) => {

            console.log(item);

            return (
                <SubjectItem
                    title = { item.title }
                    qualification = { item.qualification }
                    level = { item.level }
                    qcf = { item.qcf }
                    scqf = { item.scqf }
                    url = { item.url }
                    filterText = { this.props.filterText }
                />
            );

        });

        const qualificationNames = {
            "Award" : "Award",
            "CFE" : "Curriculum for Excellence",
            "Certificate" : "Certificate",
            "Diploma" : "Diploma",
            "HN" : "Higher National",
            "HNC" : "Higher National Certificates",
            "HND" : "Higher National Diplomas",
            "IVA" : "International Vocational Awards",
            "NC" : "National Certificates",
            "NPA" : "National Progression Awards",
            "NQ" : "National Qualifications",
            "NQGA" : "National Qualification Group Awards",
            "NVQ" : "National Vocational Qualifications",
            "National Workplace Award" : "National Workplace Award",
            "Other" : "Other",
            "PDA" : "Professional Development Awards",
            "QCF" : "Qualifications and Credit Framework",
            "SPA" : "Scottish Progression Awards",
            "SVQ" : "Scottish Vocational Qualifications"
        };

        var qualification = this.props.qualification;
        var qualificationName = qualificationNames[qualification];

        return (
            <div className="qualification--detail">
                <h3 id={this.props.qualification} className="qualification--detail--title">
                    { qualificationName }
                </h3>
                <ul className="qualification--detail--items list__presentational">
                    { items }
                </ul>
            </div>
        );

    }

});

export default QualificationDetails;


/** WEBPACK FOOTER **
 ** ./app/QualificationDetails.jsx
 **/